import React from 'react';
import { Box } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
import type { AccommodationListingDTO, AccommodationsConsoleState, RenderListingEntryFn } from '@shared/types/Accommodations.types';
import { useOuterClick } from '@shared/utils/hooks/useOuterClick';
import type { HotelSearchSource } from '@shared/constants/accommodations';

type SingleHotelViewProps = Readonly<{
  onClose: () => void;
  listings: ReadonlyArray<AccommodationListingDTO>;
  selectedHotelId: Maybe<string>;
  state: AccommodationsConsoleState;
  noOfNights: number;
  sourceName: HotelSearchSource;
  renderListingEntry: RenderListingEntryFn;
}>;

export const SingleHotelView = (props: SingleHotelViewProps) => {
  const { onClose, listings, selectedHotelId, state, noOfNights, sourceName, renderListingEntry } = props;
  const viewBoxRef = useOuterClick(onClose, !!selectedHotelId);

  const currentHotel = listings.find(listing => listing.joyPlaceId === selectedHotelId);

  if (!currentHotel) return null;

  return (
    <Box
      position="fixed"
      bottom={0}
      left={0}
      right={0}
      backgroundColor="white"
      maxHeight={'97%'}
      borderTopLeftRadius={pxToRem(12)}
      borderTopRightRadius={pxToRem(12)}
      boxShadow="0px -7px 16px -8px rgba(0, 0, 0, 0.3), 0px -10px 27px -5px rgba(44, 41, 37, 0.25)"
      overflowY="auto"
      zIndex="dropdown"
      ref={viewBoxRef}
    >
      <Box padding={6}>{renderListingEntry({ listing: currentHotel, state, noOfNights, sourceName })}</Box>
    </Box>
  );
};
